import type { JSX } from 'react';
import type { UseFormRegister, FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { EducationLevelSelect } from './EducationLevelSelect';
import { LocationFields } from './LocationFields';
import { YearFields } from './YearFields';

export interface EducationFormData {
  educationLevel: string;
  institution: string;
  educationField: string;
  city: string;
  country: string;
  yearBegin: string;
  yearEnd: string;
}

interface EducationFormFieldsProps {
  register: UseFormRegister<EducationFormData>;
  errors: FieldErrors<EducationFormData>;
  setValue: UseFormSetValue<EducationFormData>;
  watch: UseFormWatch<EducationFormData>;
}

export function EducationFormFields({
  register,
  errors,
  setValue,
  watch,
}: EducationFormFieldsProps): JSX.Element {
  return (
    <div className="space-y-4">
      <EducationLevelSelect
        value={watch('educationLevel')}
        onChange={(v) => setValue('educationLevel', v)}
        error={errors.educationLevel?.message}
      />
      <div className="space-y-2">
        <Label htmlFor="institution">
          Institution <span className="text-destructive">*</span>
        </Label>
        <Input
          id="institution"
          placeholder="University name"
          {...register('institution', { required: 'Institution is required' })}
        />
        {errors.institution && (
          <p className="text-sm text-destructive">{errors.institution.message}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="educationField">
          Field of Study <span className="text-destructive">*</span>
        </Label>
        <Input
          id="educationField"
          placeholder="Computer Science"
          {...register('educationField', { required: 'Field of study is required' })}
        />
        {errors.educationField && (
          <p className="text-sm text-destructive">{errors.educationField.message}</p>
        )}
      </div>
      <LocationFields
        register={register}
        errors={errors}
        country={watch('country')}
        onCountryChange={(v) => setValue('country', v)}
      />
      <YearFields register={register} errors={errors} />
    </div>
  );
}
